// extracted by mini-css-extract-plugin
export default {"root":"NotFoundPage_root__COzzp","text":"NotFoundPage_text__z7rD6"};